import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import { getCodeVerifier } from './utils'

import './styles/reset.css'
import 'uno.css'
import './styles/main.less'
import pinia from './store' // 确保路径正确

const app = createApp(App)
app.use(pinia) // 在所有其它插件之前安装 pinia

const lang = process.env.LANG || 'en'
if (lang === 'ar') {
  document.documentElement.setAttribute('dir', 'rtl')
  document.documentElement.setAttribute('class', 'direction-rtl')
} else {
  document.documentElement.setAttribute('dir', 'ltr')
}
if (lang === 'ru') {
  try {
    import('@vkid/sdk').then(VKID => {
      console.log(VKID, 332)

      // 或者使用完整路径，如：`/static/js/vk-sdk@2.5.2.js`
      // 初始化 VK SDK
      const codeVerifier = getCodeVerifier()
      const appId = 53044307
      let baseURL = import.meta.env.VITE_BASE_URL
      if (process.env.VITE_MODE !== 'production') {
        baseURL = 'https://tapon-api-test.joyread.cc'
      }
      VKID?.Config.init({
        app: appId,
        redirectUrl: `${baseURL}/web/socialiteRedirect/vk/${appId}?code_verifier=${codeVerifier}&z_lang=${lang}`,
        responseMode: VKID.ConfigResponseMode.Callback,
        source: VKID.ConfigSource.LOWCODE,
        scope: '',
        mode: VKID.ConfigAuthMode.Redirect,
        codeVerifier,
      })
      window.VKIDSDK = VKID
    })
  } catch (error) {
    console.error('Failed to load VK SDK:', error)
    // 处理加载失败的情况
  }
}
if (['production'].includes(process.env.VITE_MODE!)) {
  Sentry.init({
    app,
    environment: process.env.VITE_MODE,
    release: process.env.SENTRY_VERSION || '0.0.1',
    dsn: 'https://425ce3ee11764bc88fffbbeaf18da421@o4504093839917056.ingest.sentry.io/4504201448521728',
    tracesSampleRate: 1.0,
  })
}

// 注入插件
Object.values(import.meta.globEager('./modules/*.ts')).forEach(i => i.install?.(app))

app.mount('#app')
